<template>
  <div>
    <div class="h-toolbarBg">
      <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
    </div>
    <div class="h100-80 h-scroll">
      <ejs-grid :dataSource="devData" ref="grid">
        <e-columns>
          <e-column type="checkbox" width="50" textAlign="center"></e-column>
          <e-column field="id" :visible="false"></e-column>
          <e-column field="neId" :visible="false"></e-column>
          <e-column field="equipmentName" :headerText="$t('Topo.devName')" width="120" textAlign="Center"></e-column>
          <e-column field="typeName" :headerText="$t('Topo.devType')" width="120" textAlign="Center"></e-column>
          <e-column field="esn" :headerText="$t('Security.Lic.esn')" width="120" textAlign="Center"></e-column>
          <e-column field="displaySoftwareVersion" :headerText="$t('Topo.devSoftVersion')" width="120" textAlign="Center"></e-column>
          <e-column field="status" :headerText="$t('Security.Lic.uploadStatus')" width="120" textAlign="Center"  :formatter='uploadStatusFormat'></e-column>
          <e-column field="uploadTime" :headerText="$t('Security.Lic.uploadTime')" width="120" textAlign="Center"  :formatter='uploadDate'></e-column>
          <e-column field="installTime" :headerText="$t('Security.Lic.installTime')" width="120" textAlign="Center"  :formatter='installDate'></e-column>
          <e-column field="activeTime" :headerText="$t('Security.Lic.activeTime')" width="120" textAlign="Center"  :formatter='actDate'></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <CustomDialog ref="upDevLicDialog"
                  v-bind:element="upDevLicDialog.element"
                  v-bind:styles="upDevLicDialog.styles">
      <template slot="dialog-content">
        <ejs-uploader ref="upDevLic" name="upLicense"
                    :asyncSettings="upDevSettings.asyncSettings"
                    :multiple="upDevSettings.multiple"
                    :autoUpload="upDevSettings.autoUpload"
                    :uploading="onFileUpload"
                    :allowedExtensions = "upDevSettings.extensions"
                    :success="uploadResult">
                    </ejs-uploader>
      </template>
    </CustomDialog>

    <CustomDialog ref="CustomDialogList"
                  v-bind:element="CustomDialogList.element"
                  v-bind:styles="CustomDialogList.styles">
      <template slot="dialog-content">
        <ejs-uploader ref="upDevLic" name="upLicense"
                    :asyncSettings="upListDevSettings.asyncSettings"
                    :multiple="upListDevSettings.multiple"
                    :autoUpload="upListDevSettings.autoUpload"
                    :uploading="onFileListUpload"
                    :allowedExtensions = "upListDevSettings.extensions"
                    :success="uploadListResult">
                    </ejs-uploader>
      </template>
    </CustomDialog>

    <CustomDialog ref="licDetailDialog"
                  v-bind:element="licDetailDialog.element"
                  v-bind:styles="licDetailDialog.styles">
      <template slot="dialog-content">
        <LicDetail ref="licDetail"></LicDetail>
      </template>
    </CustomDialog>

    <CustomDialog ref="licHistoryDialog"
                  v-bind:element="licHistoryDialog.element"
                  v-bind:styles="licHistoryDialog.styles">
      <template slot="dialog-content">
        <LicHistory ref="licHistory"></LicHistory>
      </template>
    </CustomDialog>

    <CustomDialog ref='filterDialog' :element='filterDialogSetting.element' :styles='filterDialogSetting.styles'>
      <template v-slot:dialog-content>
        <LicFilter url='/lte/ems/license4g/downloadEquipment' ref='filterContent' :hasStatus='true'></LicFilter>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from '../../common/CustomDialog';
import LicFilter from './LicFilter';
import LicDetail from './licDetail4G';
import LicHistory from './licHistory';
import { EventBus } from "../../../plugins/eventBus";
import { resolve } from 'url';

export default {
    name: 'DeviceLicense',
    components: {
      LicFilter,
      CustomDialog,
      LicDetail,
      LicHistory
    },
    data() {        
      return {
        devData: [],
        toolbarItems: [
          { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshList },
          { prefixIcon: 'icon hero-icon hero-icon-upload', tooltipText: this.$t('Common.upload'), click: this.showUpload },
          { prefixIcon: 'icon hero-icon hero-icon-batch-upload', tooltipText: this.$t('Common.Listupload'), click: this.showListUpload },
          { prefixIcon: 'icon hero-icon hero-icon-download', tooltipText: this.$t('Software.download'), click: this.export },
          { prefixIcon: 'icon hero-icon hero-icon-topo-mc_pf', tooltipText: this.$t('Security.install'), click: this.install },
          { prefixIcon: 'icon hero-icon hero-icon-confirm', tooltipText: this.$t('Security.active'), click: this.activeLicense },
          { prefixIcon: 'icon hero-icon hero-icon-export', tooltipText: this.$t('Alarm.export'), click: this.filterLicense },
          // { prefixIcon: 'icon hero-icon hero-icon-synchronize',tooltipText: this.$t('Alarm.synchronize'), click: this.syncDevLicense},
          { prefixIcon: 'icon hero-icon hero-icon-details', tooltipText: this.$t('Common.detail'), click: this.showDetail },
          { prefixIcon: 'icon hero-icon hero-icon-replenish-data', tooltipText: this.$t('Security.history'), click: this.showHistory }
        ],
        upDevLicDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'upDevLicDialog',
            buttonGroup: [
              {
                click: this.closeUpload,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Login.uploadLicense')}`
          },
          styles: {
            width: '600px',
            height: '400px',
            model: true,
            visible: false
          }
        },
        filterDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Alarm.exportSetting'),
          refName: 'filter',
          isClose: true,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('Alarm.cancel') } },
            // { click: this.filterFilterFunc, buttonModel: { content: this.$t('Alarm.filter'), isPrimary: true } },
            { click: this.filterConfirmFunc, buttonModel: { content: this.$t('Alarm.export'), isPrimary: true } }
          ]
        }
      },
        CustomDialogList: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'CustomDialogList',
            buttonGroup: [
              {
                click: this.closeListUpload,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Login.uploadListLicense')}`
          },
          styles: {
            width: '600px',
            height: '700px',
            model: true,
            visible: false
          }
        },
        
        licDetailDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'licDetailDialog',
            buttonGroup: [
              {
                click: this.closeDetail,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Security.Lic.licenseDetail')}`
          },
          styles: {
            width: '800px',
            height: '500px',
            model: true,
            visible: false
          }
        },
        licHistoryDialog: {
          element: {
            target: '#app',
            isClose: true,
            refName: 'licHistoryDialog',
            buttonGroup: [
              {
                click: this.closeHistory,
                buttonModel: { content: `${this.$t('Common.close')}` }
              }
            ],
            title: `${this.$t('Security.Lic.licenseHistoryDetail')}`
          },
          styles: {
            width: '1200px',
            height: '500px',
            model: true,
            visible: false
          }
        },
        upDevSettings: {
          asyncSettings: {
            saveUrl: '/lte/ems/license4g/uploadDeviceLicense',
            removeUrl: ''
          }, 
          multiple: false,
          autoUpload: false,
          extensions: '.enc'
        },
        upListDevSettings: {
          asyncSettings: {
            saveUrl: '/lte/ems/license4g/uploadDeviceListLicense',
            removeUrl: ''
          },
          multiple: true,
          autoUpload: false,
          extensions: '.enc'
        },
      }
    },
  methods: {
    actStatusFormat(grids, data) {
      if(data.activeStatus == 1){
         return `${this.$t('Security.Lic.activeStatus_activated')}`;
      }else{
        return `${this.$t('Security.Lic.activeStatus_inactivated')}`;
      }
    },
    uploadStatusFormat(grids, data) {
      if(data.status == null){
        return `${this.$t('Security.Lic.uploadStatus_unupload')}`;
      }else if(data.status == 1){
         return `${this.$t('Security.Lic.uploadStatus_uploaded')}`;
      }else if(data.status == 2){
         return `${this.$t('Security.Lic.installStatus')}`;
      }else if(data.status == 3){
        return `${this.$t('Security.Lic.activeStatus_activated')}`;
      }
    },
    actDate(grids, data) {
      if(!!data.activeTime&&data.activeTime!=null){
        return this.formatDateTime(data.activeTime);
      }else{
        return '';
      }
    },
    uploadDate(grids, data) {
        if(!!data.uploadTime&&data.uploadTime!=null){
          return this.formatDateTime(data.uploadTime);
        }else{
          return '';
        }
    },
    installDate(grids, data) {
        if(!!data.installTime&&data.installTime!=null){
          return this.formatDateTime(data.installTime);
        }else{
          return '';
        }
    },
    formatDateTime(timeStamp) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? ('0' + minute) : minute;
        second = second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
    },

    findDevList() {
      let url = '/lte/ems/license4g/findLicDevList';
      let That = this;
      this.axios.get(url, {}).then(response => {
        let result = response.data;
        That.devData = result;
      });
    },
    checkSelectRecord() {
      let record = this.$refs.grid.getSelectedRecords();
      if (record === null || record === '') {
        this.eventEmit('warning',`${this.$t('Common.tips.noSelect')}`);
        return false;
      }
      if (record.length === 0) {
        this.eventEmit('warning',`${this.$t('Common.tips.selectOne')}`);
        return false;
      }
      if (record.length !== 1) {
        this.eventEmit('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return false;
      }
      return true;
    },
    checkSelectRecordList(){
      let record = this.$refs.grid.getSelectedRecords();
        if (record === null || record === '') {
          this.eventEmit('warning',`${this.$t('Common.tips.noSelect')}`);
          return false;
        }
        if (record.length === 0) {
          this.eventEmit('warning',`${this.$t('Common.tips.selectOne')}`);
          return false;
        }
        return true;
    },
    onFileUpload(args) {
      let record = this.$refs.grid.getSelectedRecords();
      args.customFormData = [{'neId': record[0].neId}]
    },
    onFileListUpload(args) {
      let record = this.$refs.grid.getSelectedRecords();
    },
    export() {
      if(this.checkSelectRecordList()){
       let That = this;
       let record = this.$refs.grid.getSelectedRecords();
       
        record.forEach(function(val){
                That.$axios.get(
                    "/lte/ems/license4g/downloadLicense?id="+val.neId,
                    { responseType: "blob" },
                    {
                        headers: {
                            "Access-Control-Allow-Origin": "*",
                        },
                    }
                ).then(res => {
            console.log(res);
            if(!!res.data ){
                let fileName = (res.headers['content-disposition'].split("="))[1]

                That.eventEmit('success',`${That.$t('成功')}`);
                var blob = new Blob([res.data], {
                        type: "application/octet-stream;chartset=UTF-8",
                    });
                let fileURL= URL.createObjectURL(blob)
                var a = document.createElement("a");
                a.href = fileURL;
                a.download = fileName
                a.click();
            }
          }).catch((error) => {
                   That.eventEmit('warning',`${That.$t('失败')}`);
                }) 
        })
       
      }   
      
    },
    showUpload() {
      if(this.checkSelectRecord()){
        this.$refs.upDevLicDialog.show();    
      }
    },/*  */

    //添加新的判定方法
    showListUpload() {
        this.$refs.CustomDialogList.show();    //父组件调用子组件的方法
    },

    install(){
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        let url = '/lte/ems/license4g/install';
        let That = this;
         if(record[0].status==0 ) {
             this.eventEmit('warning',`${That.$t('Security.Lic.unUpload')}`);
         } else if(record[0].status!=1){
            this.eventEmit('warning',`${That.$t('Security.Lic.installed')}`);
         } else{
          this.$axios.post(url, 'neId='+record[0].neId).then(res => {
            console.log(res);
            if(!!res.data && res.data.success==0){
              That.eventEmit('success',res.data.msg);
              That.findDevList();
            }else{
              That.eventEmit('error',`${That.$t('Common.tips.failure')}`+':'+res.data.msg);
            }
          })
        }
      }
    },
    showDetail() {
       let That = this;
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();

        if(record[0].status==3) {
           this.$axios.get("/lte/ems/license4g/qryNodeLinkStatus?id="+record[0].neId).then(res => {
            console.log(res);
            if(!!res.data && res.data.success==0 ){
              if(res.data.status == 1){
                this.$refs.licDetail.findDevLicense(record[0].neId);
                this.$refs.licDetailDialog.show();
              }else{
                this.eventEmit('warning',`${That.$t('MCS.neOffLine')}`);
              }
            }
          })

        }else {
          this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense')}`);
        }
      }
    },
    showHistory(){
      let That = this;
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        this.$refs.licHistory.findDevLicenseHistory(record[0].neId);
        this.$refs.licHistoryDialog.show();

      }
    },
    filterConfirmFunc(clickEvent) {
      if (clickEvent.keyCode === 13) {
        return;
      }
      // 导出EXCEL
      
      this.$refs.filterContent.exportExcel();
      this.dialogHide();
      EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
      
    },
    dialogHide() {
     this.$refs.filterDialog.clear();
      this.$refs.filterDialog.close();
    },
    closeDetail() {
      this.$refs.licDetailDialog.clear();
      this.$refs.licDetailDialog.close();
    },
    closeHistory() {
      this.$refs.licHistoryDialog.clear();
      this.$refs.licHistoryDialog.close();
    },
    activeLicense() {
      if(this.checkSelectRecord()){
        let record = this.$refs.grid.getSelectedRecords();
        let url = '/lte/ems/license4g/actDeviceLicense';
        let That = this;
        console.log(record)
         if(record[0].status == null ) {
             this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip1')}`);
         } else if(record[0].status==1){
            this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip2')}`);
         } else if(record[0].status==3){
            this.eventEmit('warning',`${That.$t('Security.Lic.activeLicense_warntip')}`);
         } else if(record[0].status==2){
          this.$axios.post(url, 'neId='+record[0].neId).then(res => {
            console.log(res);
            if(!!res.data && res.data.success==0){
              That.eventEmit('success',res.data.msg);
              That.findDevList();
            }else{
              That.eventEmit('error',`${That.$t('Common.tips.failure')}`+':'+res.data.msg);
            }
          })
        }
      }
    },
    filterLicense() {
       // 告警过滤
      this.$refs.filterDialog.show();
      //this.$refs.filterContent.setTopoList(this.topoList);
      //this.$refs.filterContent.setConditions(this.queryConditions.conditions);
      
    },
    syncDevLicense(){
      if(this.checkSelectRecord()){

        let record = this.$refs.grid.getSelectedRecords();

         if(record[0].activeStatus!=1 &&record[0].uploadStatus!=1) {
          let url = '/lte/ems/license4g/syncDeviceLicense';
          let That = this;
          this.$axios.post(url, 'neId='+record[0].neId).then(res => {

          if(!!res.data && res.data.success==0){
            That.eventEmit('success',res.data.msg);
            That.findDevList();
          }else{
            That.eventEmit('error',`${That.$t('Common.tips.failure')}`);
          }
        })
        }else {
          this.eventEmit('warning',`${That.$t('Security.Lic.syncDevLicense_warntip')}`);
        }
      }
    },
    closeUpload() {
      this.$refs.upDevLicDialog.clear();
      this.$refs.upDevLicDialog.close();
      this.findDevList();
    },
    closeListUpload() {
      this.$refs.CustomDialogList.clear();
      this.$refs.CustomDialogList.close();
      this.findDevList();
    },
    uploadResult(args) {
     
      let event = args.e;
      let info = event.target.responseText;
      document.getElementsByClassName("e-file-status")[0].innerHTML = info;
    },
    uploadListResult(args) {
      let event = args.e;
      let info = event.target.responseText;
      let lteinfo = JSON.parse(info);
      let allfiles = document.getElementsByClassName("e-file-container")
      console.log("document.getElementsByClassName)===",document.getElementsByClassName("e-file-status"))
      for(let i = 0;i <allfiles.length;i++){
        console.log("allfiles[i]===",allfiles[i].firstChild.getAttribute("title"))
        if(allfiles[i].firstChild.getAttribute("title")==lteinfo.ESN){
          const textDom = document.createElement('span');
          textDom.innerHTML = lteinfo.msg;
          allfiles[i].classList.add('hiddenStatus');
          allfiles[i].appendChild(textDom);
          
        }
      }
    },
    refreshList() {
      this.findDevList();
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  },
  mounted() {
      this.findDevList();
  }
}
</script>

<style>
.e-upload .e-upload-files .e-upload-file-list .e-file-container.hiddenStatus .e-file-status {
  display: none;
}

.e-file-container {
  color: #28a745;
}

</style>